import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { ReferralStats as ReferralStatsBase } from "./ReferralStats";

export type * from "./ReferralStats";
export const ReferralStats = withLoyaltyStore(ReferralStatsBase, "ReferralStats");
